import Picture from "@/components/common/Picture";
import TextField from "@/components/site-builder/TextField";
import type { ImageGalleryBlock, ImageGalleryModuleType } from "../types";
import BaseImageBlock from "../BaseImageBlock";
import { AnchorType, DisplayVariant } from "../constants";

export interface MapperProps {
  module: ImageGalleryModuleType;
  block: ImageGalleryBlock;
}

export default function Mapper(props: MapperProps) {
  const { module, block } = props;
  const {
    style: {
      display: { displayVariant },
    },
    body: { lightboxEnabled: lightbox },
  } = module;

  const anchorType = lightbox ? AnchorType.Button : AnchorType.Anchor;
  const mediaContent = <Picture imageConfig={block.image} baseBorderRadius />;

  switch (displayVariant) {
    case DisplayVariant.Variant1:
      return (
        <BaseImageBlock as={anchorType} block={block} lightbox={lightbox}>
          {mediaContent}
          <TextField field={block.title} type="text-large" />
        </BaseImageBlock>
      );

    case DisplayVariant.Variant2:
      return (
        <BaseImageBlock as={anchorType} block={block} lightbox={lightbox}>
          {mediaContent}
        </BaseImageBlock>
      );

    default:
      return null;
  }
}
